/**
 * Checks if the given parameter object has any URLs defined.
 * @param {object} urls - The URLs object of the project.
 * @returns {boolean} True if the project has URLs, False otherwise.
 */
export function getProjectHasUrls(urls: object): boolean {
    // If the urls object is null, undefined, or has no keys, return false.
    if (
        !urls ||
        Object.keys(urls).length === 0
    ) {
        return false;
    }

    return true;
}